var Account = /** @class */ (function () {
    /**
     *
     * @param config KeyCloakOIDC json config
     * @param redirect
     */
    function Account(config, redirect) {
        if (redirect === void 0) { redirect = ''; }
        var _this = this;
        /**
         *
         * @returns url to access account page
         */
        this.getUrl = function () {
            return "".concat(_this.config['auth-server-url'], "realms/").concat(_this.config.realm, "/account/").concat(_this.redirect !== '' ? "?referrer=".concat(_this.config.resource, "&referrer_uri=").concat(_this.redirect) : '');
        };
        this.config = config;
        this.redirect = redirect;
    }
    return Account;
}());
export default Account;
